import React from "react"
import { Link, useLocation } from "react-router-dom"
import { Logo } from "./logo"

type LogoSize = "sm" | "md" | "lg" | "xl"

interface SmartLogoProps {
    size?: LogoSize
    className?: string
}

export function SmartLogo({ size = "md", className }: SmartLogoProps) {
    const location = useLocation()

    // Determine navigation target based on context
    const getNavigationTarget = () => {
        const pathname = location.pathname

        // If we're on the landing page or public pages, go to home
        if (
            pathname === "/" ||
            pathname.startsWith("/login") ||
            pathname.startsWith("/signup") ||
            pathname.startsWith("/otp") ||
            pathname.startsWith("/features") ||
            pathname.startsWith("/how-it-works") ||
            pathname.startsWith("/testimonials") ||
            pathname.startsWith("/pricing")
        ) {
            return "/"
        }

        // If user is on the dashboard (organization manager), go to home
        if (pathname.startsWith("/dashboard") || pathname.startsWith("/ft-dashboard")) {
            return "/"
        }

       // If user is on the employee dashboard, clicking logo should take them back to employee dashboard
        if (pathname.startsWith("/employee")) {
            return "/employee/dashboard"
        }

        // If user is on a service-specific page (recruitment/onboarding),
        // clicking logo should take them back to the main dashboard (organization manager)
        if (pathname.startsWith("/recruitment") || pathname.startsWith("/onboarding") ||
            pathname.startsWith("/account") || pathname.startsWith("/profile") ||
            pathname.startsWith("/billing")) {
            return "/dashboard"
        }

        // Default to home for everything else
        return "/"
    }

    const navigationTarget = getNavigationTarget()

    return (
        <Link to={navigationTarget} className="-m-1.5 p-1.5">
            <span className="sr-only">TEMPERED TALENT</span>
            <Logo size={size} className={className} />
        </Link>
    )
}